import { ObjectPrototype } from "@/models/objectPrototype.js"

// Post blueprint
export class Post extends ObjectPrototype {
    constructor(id) {
        //console.log("Create post id=", id)
		super(id)

		this.metrics = new Map()
    }

    // Some passport key names (not all)
    static get passportKeys() {
        const proprietaryKeys = {
            ipAddress: "ip",
            isRegistered: "is_registered",
            
            controlType: "control_type",

            notificationDistributionLists: {
                self: 'notification_distribution_lists',
                connection: 'connection',
                potentialOutOfRange: 'potential_out_of_range',
            },
        }

        return Object.freeze({... ObjectPrototype.passportKeys, ... proprietaryKeys})
    }

    static get settingNames() {
        const proprietaryNames = {
            [Post.passportKeys.controlType]: 'Тип контролю ПВ',
            [Post.passportKeys.isActive]: 'КВП активний?',
            [Post.passportKeys.isRegistered]: 'Зареестрований?',
        }

        return Object.freeze({... ObjectPrototype.settingNames, ... proprietaryNames})
    }

    static get notificationNames() {
        const notifications = Post.passportKeys.notificationDistributionLists
        delete notifications.self
    
        return Object.values(notifications)
    }

	// Metrics key names
    static get metricsKeys() {
        return Object.freeze({
            Emin: "E_min",
            Eavg: "E_avg",
            Emax: "E_max",
            Vbat: "v_bat_instant",
            connection_quality: "connection_quality_instant",
            IMEI: "imei_instant",
        })
    }

    // Тип контролю ПВ
    static get postControlType() {
        return Object.freeze({
            p_1: Object.freeze({
                key: "p_1",
                title: "Точка дренажу УКЗ",
            }),
            p_2: Object.freeze({
                key: "p_2",
                title: "Точка дренажу УДЗ",
            }),
            p_3: Object.freeze({
                key: "p_3",
                title: "Точка дренажу установки протекторного захисту",
            }),
            p_4: Object.freeze({
                key: "p_4",
                title: "Точка мінімального потенціалу",
            }),
            p_5: Object.freeze({
                key: "p_5",
                title: "Зона дії блукаючих струмів",
            }),
            p_6: Object.freeze({
                key: "p_6",
                title: "Ізолювальний фланець",
            }),
            p_7: Object.freeze({
                key: "p_7",
                title: "Кожух на транспортному переході",
            }),
            p_8: Object.freeze({
                key: "p_8",
                title: "Водний перетин",
            }),
            p_9: Object.freeze({
                key: "p_9",
                title: "Перетин з високовольною ЛЕП",
            }),
            p_10: Object.freeze({
                key: "p_10",
                title: "Перетин з підземними комунікаціями",
            }),
            p_11: Object.freeze({
                key: "p_11",
                title: "Суміжна споруда",
            }),
            p_12: Object.freeze({
                key: "p_12",
                title: "Обсадна колона",
            }),
        })
    }

	getMetric(metricName, unit="any") {
		if (this.metrics.has(metricName) && unit) {
			return this.metrics.get(metricName)
		} else {
			return undefined
		}
    }

    subscribeToNotification(userId, notificationKey) {
        let notificationDistributionLists = this.passport.get(Post.passportKeys.notificationDistributionLists.self)
        if (!notificationDistributionLists) {
            this.passport.set(Post.passportKeys.notificationDistributionLists.self, new Object())
            notificationDistributionLists = this.passport.get(Post.passportKeys.notificationDistributionLists.self)
        }

        // if no list at all
        if (notificationDistributionLists[notificationKey] === undefined) {
            notificationDistributionLists[notificationKey] = []
        }

        // If current user is not in distribution notifications list
        if (!notificationDistributionLists[notificationKey].includes(userId)) {
            notificationDistributionLists[notificationKey].push(userId)
        }
    }

    unsubscribeFromNotification(userId, notificationKey) {
        let notificationDistributionLists = this.passport.get(Post.passportKeys.notificationDistributionLists.self)
        if (!notificationDistributionLists) {
            this.passport.set(Post.passportKeys.notificationDistributionLists.self, new Object())
            notificationDistributionLists = this.passport.get(Post.passportKeys.notificationDistributionLists.self)
        }

        // If current user is in distribution notifications list
        if (notificationDistributionLists[notificationKey] !== undefined
            && notificationDistributionLists[notificationKey].includes(userId)
        ) {
            const index = notificationDistributionLists[notificationKey].indexOf(userId);
            notificationDistributionLists[notificationKey].splice(index, 1)
        }
    }
}